<template>
    <div v-if="table">
        <div v-if="table.isLoading && !table.loadingMoreData" class="loading"><span class="loader">Loading...</span></div>
        <div class="scroll-table" id="scrollTable">
            <div v-if="!table.isLoading && tableData && tableData.length === 0" class="no-data">
                <template v-if="$route.name === 'news'">{{noDataMessage}}</template>
                <template v-else>{{noDataErrorMsg}}</template>
            </div>
            <table class="data-table" v-if="tableData && tableData.length > 0">
                <thead>
                    <tr>
                        <template v-for="(col, index) in table.columns">
                        <th v-bind:key="index" v-if="!col.rowData && col.isVisible" :colspan="col.colSpan ? col.colSpan : 1" :class="{'sortby': isSortOnThisColumn(col), 'sortable': isSortableColumn(col) === true, 'asc': table.sortOrder == 'asc', 'desc': table.sortOrder == 'desc', ['column-' + col.fieldName]: true}" @click.prevent="setSortDetails($event, col)">
                            <span v-html="col.displayName" :class="col.headerClass"
                                 :title="(isSortableColumn(col) ? 'Sort By ' : '') + (col.helpText ? (col.helpText === 'fieldName' ? col.displayName : col.helpText) : '')"
                            ></span>
							<i class="fa fa-angle-down arrow down" v-if="isSortOnThisColumn(col) && table.sortOrder === 'desc'"  />
							<i class="fa fa-angle-up arrow up" v-if="isSortOnThisColumn(col) && table.sortOrder === 'asc'"  />
                            <a v-if="col.dataToolTip" class="me-2 ms-1" data-bs-toggle="tooltip" 
                                :data-bs-title="col.dataToolTip"> <i class="svg fas fa-question-circle"></i>
                            </a>
                        </th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(row, $index) in tableData" v-bind:key="$index">
                        <template v-for="(col, index) in table.columns">
                        <tr  v-if="col.rowData" v-bind:key="$index+''+index" class="title-row" :id="'data-row' + $index">
                            <td v-bind:colspan="table.totalColumns" class="title-row" :class="'column-' + col.fieldName" :data-label="col.displayName">
                                <template v-if="col.refURL && ((col.conditionalField && row[col.conditionalField]) || !col.conditionalField)">
                                    <a @click="trackThis(col); goToPage(row, col, $index)" :target="col.internalLink ? '' : '_blank'" :href="buildURLString(row, col, index)" rel="noopener">{{ filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}</a>
                                </template>
                                <span v-else>{{row[col.fieldName]}}</span>
                            </td>
                        </tr>
                        </template>
                        <tr>
                            <template v-for="(col, index, colCount) in table.columns">
                                <template  v-if="!col.rowData && col.isVisible">
                                <td  v-bind:key="index" v-if="checkIfVisible(col, row, colCount)" :class="col.cssClass + ' ' + 'column-' + col.fieldName" v-bind:colspan="getColSpan(col, row, colCount)" :data-label="col.displayName">
                                    <span  v-if="isObject(row[col.fieldName], col.fieldName)">
                                        <span v-if="row[col.fieldName]">
                                            <template v-if="!Array.isArray(row[col.fieldName])">
                                                {{ filters.globalFormat(row[col.fieldName][col.subField], (col.formatType ? col.formatType : ''))}}
                                            </template>
                                            <template v-else v-for="(subCol, index2) in getSortedList(row[col.fieldName])">
                                                <div class="spacer" v-if="col.callFunctionOnClick" v-bind:key="$index+''+index2" :class="{'contact-pi-link': subCol.role_code === 'PI'}">
                                                    <template  v-if="col.callFunctionOnClick && !selectedPerson && subCol['profile_id'] !== null  && (typeof subCol !== 'string')">
                                                        <a href @click.prevent="showDrillDownTable({data: subCol, field: col.subField, isPopOut: true, isPINameField: true})"  rel="noopener">
															<i class="fas fa-user icon-contact-pi" v-if="subCol.role_code === 'PI'" title="Contact PI"/>
                                                            {{ filters.globalFormat(subCol[col.subField], (col.formatType ? col.formatType : ''))}}
															<i class="fa fa-external-link-alt widget-button-icon icon-exit-link" alt="Popout"/>
                                                            <span class="sr-only">{{col.displayName}}</span>
                                                        </a>
                                                    </template>
                                                    <template v-else-if="col.callFunctionOnClick && subCol[col.subField] !== ''">
                                                        <template v-if="selectedPerson">
                                                            <template v-if="selectedPerson.name === subCol[col.subField]">{{filters.globalFormat(subCol[col.subField], (col.formatType ? col.formatType : ''))}}</template>
                                                            <a v-else href @click.prevent="showDrillDownTable({data: subCol, field: col.subField, isPopOut: true, isPINameField: true})" rel="noopener">
																<i class="fas fa-user icon-contact-pi" v-if="subCol.role_code === 'PI'" title="Contact PI"/>
                                                                {{ filters.globalFormat(subCol[col.subField], (col.formatType ? col.formatType : ''))}}
                                                                <span class="sr-only">{{col.displayName}}</span>
                                                            </a>
                                                        </template>
                                                        <a v-else-if="col.subField" @click.prevent="trackThis(col);  goToPage(subCol, col)" href :class="{'button': col.fieldType === 'button'}" rel="noopener">
                                                            {{ filters.globalFormat(subCol[col.subField], (col.formatType ? col.formatType : ''))}}
                                                        </a>
                                                        <a v-else  @click.prevent="trackThis(col);  goToPage(subCol, col)" href :class="{'button': col.fieldType === 'button'}" rel="noopener">
                                                            {{ filters.globalFormat(subCol, (col.formatType ? col.formatType : ''))}}
                                                            <span class="sr-only">{{col.displayName}}</span>
                                                        </a>
                                                        <br />
                                                    </template>
                                                    <span v-else-if="col.fieldType && col.fieldType === 'icon'" :class="{'icon': col.fieldType === 'icon'}">
                                                        <template v-for="(icon, iconInd) in col.icons">
                                                            <a @click="trackThis(col); goToPage(subCol, icon)" :href="subCol[icon.refURLField]" target="_blank"  v-if="subCol[icon.refURLField]" rel="noopener">
																<i class="fas fa-filter row-button-icon"></i>
                                                                <span class="sr-only">{{col.displayName}}</span>
                                                            </a>
                                                            <a v-else-if="icon.refURL  && ((icon.conditionalField && subCol[icon.conditionalField]) || !icon.conditionalField)"
                                                                @click="trackThis(col); goToPage(subCol, icon, iconInd)"
                                                                :href="buildURLString(subCol, icon, iconInd)" :target="col.internalLink ? '' : '_blank'" rel="noopener">
																<i class="row-button-icon" :class="icon.name"/>
                                                                <span class="sr-only">{{col.displayName}}</span>
                                                            </a>
                                                        </template>
                                                    </span>
                                                    <span v-else-if="subCol['profile_id'] !== null"><i class="fas fa-user icon-contact-pi" v-if="subCol.role_code === 'PI'" title="Contact PI"/>
                                                        <a v-if="selectedPerson" href @click.prevent="showDrillDownTable({data: subCol, field: col.subField, isPopOut: true, isPINameField: true})" rel="noopener">{{ filters.globalFormat(subCol[col.subField], (col.formatType ? col.formatType : 'total_cost'))}}</a><i class="fa fa-external-link-alt widget-button-icon icon-exit-link" alt="Popout"/>
                                                        <span class="sr-only">{{col.displayName}}</span>
                                                    </span>
                                                    <!-- <span v-if="subCol.role_code === 'PI'" class="sub-text"> - Contact</span> -->
                                                </div>
                                                <span v-else-if="col.fieldType && col.fieldType === 'icon'" :class="{'icon': col.fieldType === 'icon'}">
                                                    <template v-for="(icon, iconInd) in col.icons">
                                                        <a @click="trackThis(col); goToPage(subCol, icon)" :href="subCol[icon.refURLField]" target="_blank"  v-if="subCol[icon.refURLField]" rel="noopener">

                                                           <i class="row-button-icon" :class="icon.name"/>
                                                           <span class="sr-only">{{col.displayName}}</span>
                                                        </a>
                                                        <a v-else-if="icon.refURL  && ((icon.conditionalField && subCol[icon.conditionalField]) || !icon.conditionalField)"
                                                            @click="trackThis(col); goToPage(subCol, icon)"
                                                            :href="buildURLString(subCol, icon, iconInd)" :target="col.internalLink ? '' : '_blank'" rel="noopener">
                                                            <i class="row-button-icon" :class="icon.name" />
                                                            <span class="sr-only">{{col.displayName}}</span>
                                                        </a>
                                                        <a v-else-if="icon.refURL  && ((icon.conditionalField && row[icon.conditionalField]) || !icon.conditionalField)"
                                                            @click="trackThis(col); goToPage(row, icon, index2)"
                                                            :href="buildURLString(row, icon, index2)" :target="col.internalLink ? '' : '_blank'" rel="noopener">
                                                            <i class="row-button-icon" :class="icon.name" />
                                                            <span class="sr-only">{{col.displayName}}</span>
                                                        </a>
                                                    </template>
                                                </span>
                                                <div class="spacer" :class="{'italics': row['subproject_id'] && col.subField === 'total_cost'}" v-else-if="col.refURL" v-bind:key="$index+''+index2">
                                                    <a @click="trackThis(col); goToPage(row, col, index2)" :href="buildURLString(row, col, index2)" :target="col.internalLink ? '' : '_blank'" :class="{'button': col.fieldType === 'button'}" rel="noopener">
                                                        {{ filters.globalFormat(subCol, (col.formatType ? col.formatType : ''))}}
                                                        <span class="sr-only">{{col.displayName}}</span>
                                                    </a>
                                                </div>
                                                <div class="spacer" :class="{'italics': row['subproject_id'] && col.subField === 'total_cost'}" v-else v-bind:key="$index+''+index2">
													  <i class="fas fa-user icon-contact-pi" v-if="subCol.role_code === 'PI'" title="Contact PI"/>
                                                     {{ filters.globalFormat(subCol[col.subField], (col.formatType ? col.formatType : ''))}}
                                                </div>
                                            </template>
                                        </span>
                                    </span>
                                    <template v-else-if="(col.refURL || col.URLFieldName) && ((col.conditionalField && row[col.conditionalField]) || !col.conditionalField)">
                                        <a @click="trackThis(col); goToPage(row, col)" :href="col.URLFieldName ? row[col.URLFieldName] : buildURLString(row, col, colCount)" :target="col.internalLink ? '' : '_blank'" :class="{'button': col.fieldType === 'button'}" v-if="!col.disabled" rel="noopener">
                                            <span v-if="col.alternateField && row[col.alternateField] != null && row.admin_icd_long_abbr !== 'ACF'">{{filters.globalFormat(row[col.alternateField], (col.formatType ? col.formatType : ''))}}
                                            </span>
                                            <span v-else-if="row.admin_icd_long_abbr === 'ACF' && col.fieldType !== 'button'">{{filters.globalFormat(row['full_project_num'], (col.formatType ? col.formatType : ''))}}
                                            </span>
                                            <span v-else-if="col.fieldName">{{ filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}
                                            </span>
                                            <span v-else-if="col.fieldType && col.fieldType === 'button'">
                                                <span class="noSmallScreen">View
													<i class="fa fa-chevron-right"></i>
                                                </span>
                                                <span class="smallScreen">View Similar Projects
                                                </span>
                                            </span>
                                            <span class="sr-only">{{col.displayName}}f</span>
                                        </a>
                                        <a v-else href @click.prevent=""  class="disabled" :class="{'button': col.fieldType === 'button'}" rel="noopener">
                                            <span v-if="col.fieldType && col.fieldType === 'button'">
                                                <span class="noSmallScreen">View
													<i class="fa fa-chevron-right"></i>
                                                </span>
                                                <span class="smallScreen">View Similar Projects
                                                </span>
                                            </span>
                                            <span class="sr-only">{{col.displayName}}</span>
                                        </a>
                                    </template>
                                    <template v-else-if="col.refURLField">
                                        <a @click="trackThis(col); goToPage(row, col)" :href="row[col.refURLField]" target="_blank" :class="{'button': col.fieldType === 'button'}" v-if="!col.disabled" rel="noopener">
                                            {{ filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}
                                            <span class="sr-only">{{col.displayName}}</span>
                                        </a>
                                    </template>
                                    <template v-else-if="col.callFunctionOnClick">
                                        <template v-if="col.fieldName === 'po_email'">
                                            <template v-if="rowIsRevealed($index)">
                                                <a v-if="row.has_email" :href="'mailto:' + row[col.fieldName]" rel="noopener">{{filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}<span class="sr-only">{{col.displayName}}</span></a>
                                                <template v-else>Unavailable</template>
                                            </template>
                                            <template v-else-if="$index === $parent.firstUnrevealedRow">
                                                <a href @click.prevent="takeColAction(row, col.fieldName, $index)" class="view-email button" rel="noopener">
                                                    View Email
                                                </a>
                                                <span class="info">Contact info is hidden by default for privacy</span>
                                            </template>
                                            <template v-else>
                                                <a href @click.prevent="takeColAction(row, col.fieldName, $index)" rel="noopener">
                                                    <span :class="'hidden-text-placeholder email' + ($index % 8)"><span>View Email</span></span>
                                                    <span class="sr-only">{{col.displayName}}</span>
                                                </a>
                                            </template>
                                        </template>
                                        <a  href @click.prevent="showDrillDownTable({data: row, field: col.fieldName, isPONameField: col.fieldName === 'full_name'})" v-else-if="row[col.fieldName] !== 0"
                                            :title="col.dataHelpText ? col.dataHelpText : ''" v-b-tooltip.hover rel="noopener">
                                            {{ filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}
                                            <span class="sr-only">{{col.displayName}}</span>
                                        </a>
                                        <span v-else>{{filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}</span>
                                    </template>
                                    <span v-else-if="col.fieldType && col.fieldType === 'icon'" :class="{'icon': col.fieldType === 'icon'}">
									    <template v-for="(icon, iconInd) in col.icons">
                                            <a v-bind:key="'icon' + index + iconInd" @click="trackThis(col); goToPage(row, icon, iconInd)"  :target="col.internalLink ? '' : '_blank'"
                                               :href="row[icon.refURLField]" v-if="row[icon.refURLField]" rel="noopener">
											   <i class="row-button-icon" :class="icon.name"/>
                                               <span class="sr-only">{{col.displayName}}</span>
                                            </a>
                                        </template>
                                    </span>
                                    <span v-else>
                                        <span v-if="col.alternateField && row[col.alternateField] != null">{{filters.globalFormat(row[col.alternateField], (col.formatType ? col.formatType : ''))}}
                                        </span>
                                        <span v-if="col.fieldName && row[col.fieldName]">{{filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}
                                        </span>
                                    </span>
                                </td>
                                </template>
                            </template>
                        </tr>
                    </template>
                </tbody>
                <tfoot v-if="tableFooter">
                    <tr v-for="(row, $index) in tableFooter" v-bind:key="'footer-'+$index" >
                        <template v-for="(col, index) in table.columns" v-bind:key="index">
                            <td v-if="col.fieldName && row[col.fieldName] && row[col.fieldName] !== 'Total'" :data-label="col.displayName">
                                <!-- <span v-if="col.fieldName && row[col.fieldName] && row[col.fieldName] !== 'Total'"> -->
                                <span>
                                    {{ filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}
                                </span>
                            </td>
                            <td v-else>{{row[col.fieldName]}}</td>
                        </template>
                    </tr>
                    <tr v-if="tableFooterNote"><td :colspan="table.totalColumns" class="footer-note">{{tableFooterNote}}</td></tr>
                </tfoot>
            </table>
            <table :id="(this.id ? 'cln-' + this.id : 'clnTable')" aria-hidden="true" class="data-table" :class="{'fixed-within': id, 'fixed-header': !id}" v-if="tableData && tableData.length > 0 && id !== 'fundingProjectDetails'">
                <thead>
                    <tr>
                        <template v-for="(col, index) in table.columns">
                        <th v-bind:key="index"
                            v-if="!col.rowData && col.isVisible" :colspan="col.colSpan ? col.colSpan : 1"
                            :class="{'sortby': isSortOnThisColumn(col), 'sortable': isSortableColumn(col) === true, 'asc': table.sortOrder == 'asc', 'desc': table.sortOrder == 'desc', ['column-' + col.fieldName]: true}"
                            @click.prevent="setSortDetails($event, col)">
                                <span v-html="col.displayName" :class="col.headerClass"
                                    :title="(isSortableColumn(col) ? 'Sort By ' : '') + (col.helpText ? (col.helpText === 'fieldName' ? col.displayName : col.helpText) : '')"
                                ></span>
								<i class="fa fa-angle-down arrow down" v-if="isSortOnThisColumn(col) && table.sortOrder === 'desc'"  />
								<i class="fa fa-angle-up arrow up" v-if="isSortOnThisColumn(col) && table.sortOrder === 'asc'"  />
                                <span v-if="col.dataToolTip" class="me-2 ms-1" data-bs-toggle="tooltip" 
                                    :data-bs-title="col.dataToolTip" @click.stop>
                                    <i class="svg fas fa-question-circle" style="pointer-events: none;"></i>
                                </span>                               
                        </th>
                        </template>
                    </tr>
                </thead>
            </table>
        </div>
        <span class="more-data-loader" v-if="table.loadingMoreData">Loading</span>
    </div>
</template>

<script>

/*

    TODO:  this should be refactored to remove all direct references to .$parent, or replace with an alternative
    ex: Bootstrap-vue table

    Temporary workarounds are in place for News page, but this is not advisable, and likely other places are broken

*/

    import {mapGetters, mapActions} from 'vuex';
    import FieldTooltip from '@/components/searchFields/FieldTooltip.vue';
    import winHandlerMixins from '@/shared/winhandlerMixins';
    import dataTableMixins from '@/shared/dataTable.mixin.js';
    import {app} from '@/main';
    import bus from '@/shared/event-bus.js';

    export default {
        name: 'dataTable',
        props: [
            'id',
            'table',
            'fromPage',
            'containerScrolling',
            'isFixedTable',
            'selectedRowId',
            'noDataMessage',
            'parentData'
        ],
        components: {
            FieldTooltip
        },
        mixins: [winHandlerMixins, dataTableMixins],
        computed: {
            ...mapGetters([
                'selectedPerson',
                'noDataErrorMsg'
            ]),
        },
        data: function () {
            return {
                scrollingTimer: 0,
                limitBy: 50,
                limitByAmount: 50,
                tableData: null,
                tableMeta: null,
                tableFooter: null,
                tableFooterNote: null,
                filters: null
            }
        },
        created () {
            var self = this;
            self.filters = app.$options.$filters;
            setTimeout(() => {
                self.initTableData(null);
            });
            bus.$off('init:datatable');
            bus.$on('init:datatable', () => {
                this.table.loadingMoreData = false;
                this.initTableData();
            });
        },
        methods: {
            ...mapActions([
                'setSelectedPerson',
                'setPersonSummaryProjects'
            ]),
            // getProjectsForPI (data) {
            //     // this.$parent
            // },
            rowIsRevealed (rowIndex) {
                return this.$parent.rowIsRevealed(rowIndex);
            },
            initTableData (data) {
                var self = this;

                self.tableFooter = null;
                self.tableFooterNote = null;
                self.tableData = null;
                self.tableMeta = null;
                switch (self.fromPage) {
                    case 'matchmaker':
                        if (self.$store.state.matchmakerResults) {
                            self.tableData = copyData(self.$store.state.matchmakerResults.results);
                            self.tableMeta = copyData(self.$store.state.matchmakerResults.meta);
                        }
                        break;
                    case 'matchmaker-po':
                        if (self.$store.state.matchmakerPOResults) {
                            self.tableData = copyData(self.$store.state.matchmakerPOResults.results);
                            self.tableMeta = copyData(self.$store.state.matchmakerPOResults.meta);
                        }
                        break;
                    case 'searchResults':
                        self.table.columns.actionItems.isVisible = true;
                        self.tableData = self.$store.state.searchResults;
                        self.tableMeta = self.$store.state.searchMeta;
                        break;
                    case 'publications':
                        self.tableData = copyData(self.$store.state.publicationResults.results);
                        self.tableMeta = self.$store.state.publicationResults.meta;
                        break;
                    case 'patents':
                        self.tableData = copyData(self.$store.state.patentResults.results);
                        self.tableMeta = self.$store.state.patentResults.meta;
                        break;
                    case 'clinicalStudies':
                        self.tableData = copyData(self.$store.state.clinicalStudyResults.results);
                        self.tableMeta = self.$store.state.clinicalStudyResults.meta;
                        break;
                    case 'PressRelease':
                    case 'ResearchMatters':
                    case 'AIRS':
                    case 'ARRA':
                    case 'AIMRS':
                            self.tableMeta = self.$store.state.newsResults[self.fromPage].meta;
                            self.tableData =  self.$store.state.newsResults[self.fromPage].results.slice(0, this.table.offset + this.table.limit);
                        break;
                    case 'piSummary':
                        self.table.columns.actionItems.isVisible = true;
                        if (self.$store.state.piSummaryProjects) {
                            self.tableData = copyData(self.$store.state.piSummaryProjects.results);
                            self.tableMeta = self.$store.state.piSummaryProjects.meta;
                        }
                        break;
                    case 'charts':
                        if (!self.parentData.loadSlide) {
                            if (self.table.columns.GroupBy)
                                self.table.columns.GroupBy.displayName = self.parentData.summaryBy.name;
                            //this.tableData = self.$store.state.graphData[this.$parent.summaryBy.value].Data;
                            self.tableData = self.$store.state.graphData.results;
                            self.tableFooter = self.$store.state.graphData.footerData;
                            self.tableFooterNote = self.$store.state.graphData.footerNote;
                        } else {
                            self.tableMeta = self.parentData.drillDownData.meta;
                            self.tableData = self.parentData.drillDownData.results;
                        }
                        break;
                    case 'circles':
                        self.tableMeta = self.parentData.circlesTableData.meta;
                        self.tableData = self.parentData.circlesTableData.results;
                        break;
                    case 'maps':
                        if (!self.$parent.loadSlide) {
                            // self.table.columns.GroupBy.displayName = self.$parent.summaryBy.name;

                            if (self.$store.state.graphData) {
                                self.tableData = self.$store.state.graphData.results;
                                self.tableMeta = self.$store.state.graphData.meta;
                            // } else {
                            //     console.log('state.graphData does not exist');
                            }
                            // self.tableFooter = self.$store.state.graphData.footerData;
                            // self.tableFooterNote = self.$store.state.graphData.footerNote;

                        // } else {
                            // self.tableData = self.$parent.drillDownData.results;
                        }
                        break;
                    case 'projectDetails':
                        switch (self.id) {
                            case 'fundingDataTable':
                                if (self.$store.state.projectDetails.basicInfo) {
                                    self.tableData =  self.$store.state.projectDetails.basicInfo.agency_ic_fundings;
                                }
                                break;
                            case 'historyDataTable':
                                if (self.$store.state.projectDetails.history) {
                                    self.tableData =  self.$store.state.projectDetails.history.results.slice(0, this.table.offset + this.table.limit);
                                    self.tableMeta =  self.$store.state.projectDetails.history.meta;
                                }
                                break;
                            case 'pubDataTable':
                                if (self.$store.state.projectDetails.publications) {
                                    self.tableData =  self.$store.state.projectDetails.publications.results;
                                }
                                break;
                            case 'patentsDataTable':
                                if (self.$store.state.projectDetails.patents) {
                                    self.tableData =  self.$store.state.projectDetails.patents.results;
                                    self.tableMeta = self.$store.state.projectDetails.patents.meta;
                                }
                                break;
                            case 'subProjectsDataTable':
                                if (self.$store.state.projectDetails.subProjects) {
                                    self.tableData =  self.$store.state.projectDetails.subProjects.results;
                                    self.tableMeta = self.$store.state.projectDetails.subProjects.meta;
                                }
                                break;
                            case 'clinicalStudiesDataTable':
                                if (self.$store.state.projectDetails.clinicalStudies) {
                                    self.tableData =  self.$store.state.projectDetails.clinicalStudies.results.slice(0, this.table.offset + this.table.limit);
                                    self.tableMeta = self.$store.state.projectDetails.clinicalStudies.meta;
                                }
                                break;
                            case 'similarProjectsDataTable':
                                if (self.$store.state.projectDetails.similarProjects) {
                                    self.tableData =  self.$store.state.projectDetails.similarProjects.results;
                                    self.tableMeta = self.$store.state.projectDetails.similarProjects.meta;
                                }
                                break;
                            case 'PressReleaseDataTable':
                                if (self.$store.state.projectDetails.PressRelease) {
                                    self.tableData =  self.$store.state.projectDetails.PressRelease;
                                }
                                break;
                            case 'ResearchMattersDataTable':
                                if (self.$store.state.projectDetails.ResearchMatters) {
                                    self.tableData =  self.$store.state.projectDetails.ResearchMatters;
                                }
                                break;
                            case 'AIRSDataTable':
                                if (self.$store.state.projectDetails.AIRS) {
                                    self.tableData =  self.$store.state.projectDetails.AIRS;
                                }
                                break;
                            case 'ARRADataTable':
                                if (self.$store.state.projectDetails.ARRA) {
                                    self.tableData =  self.$store.state.projectDetails.ARRA;
                                }
                                break;
                            case 'AIMRSTableDataTable':
                                if (self.$store.state.projectDetails.AIMRS) {
                                    self.tableData =  self.$store.state.projectDetails.AIMRS;
                                }
                                break;
                        }
                        break;
                    default:
                        self.table.columns.GroupBy.displayName = self.$parent.summaryBy.name;
                        self.tableData = self.$store.state.graphData.results;
                }
                setTimeout(() => {
                    if (self.tableData && self.tableData.length > 0) {
                        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                            return new bootstrap.Tooltip(tooltipTriggerEl)
                        });
                        if (self.containerScrolling === "false") {
                            window.fixHeaders('scrollTable');
                        } else {
                            self.fixSubPageTableHeaders();
                        }
                        if (self.$store.state.selectedRowId && document.getElementById('data-row' + self.$store.state.selectedRowId)) {
                            document.getElementById('data-row' + self.$store.state.selectedRowId).scrollIntoView();
                        }
                    }
                }, 101);
            },
            isSortableColumn (col) {
                return !!col.isSortable;
            },
            isSortOnThisColumn (col) {
                var sortFieldName = col.fieldName;


                if (col.sortFieldName) {
                    sortFieldName = col.sortFieldName;
                } else if (col.subField) {
                    sortFieldName = col.subField;
                }

                if (sortFieldName !== '' && this.table.sortField === sortFieldName) {
                    return true;
                } else if (this.tableMeta && this.tableMeta.sort_field && this.tableMeta.sort_field === sortFieldName) {
                    return true;
                } else  if (this.fromPage !== 'searchResults') {
                    return this.table.sortField === col.fieldName && col.fieldName !== '';
                }

                return false;
            },
            trackThis (col, subCol) {
				gtag('event', 'Click', {
					'event_category': 'Search Results',
					'event_label': 'Search Results - clicked on ' + col.displayName + ' (' + col.fieldName + ')',
					'value': 'Search Results - clicked on ' + col.displayName + ' (' + col.fieldName + ')'
				});	
            },
            goToPage (row, col, index) {
                if (col.internalLink) {
                    event.preventDefault();
                    index = index === 0 ? 0 : index - 1;

                    var url = this.buildURLString(row, col, index);
                    if (url !== '' && this.$route.path !== url) {
                        if (event.ctrlKey || event.metaKey) {
                            let routeData = this.$router.resolve({path: url});
                            window.open(routeData.href, '_blank');
                        } else {
                            let urlParts = url.split('#');
                            this.$router.push({
                                path: urlParts[0], hash: (urlParts.length > 1 ? '#'+urlParts[1] : '')
                            });
                        }
                    }
                }
                return false;
            },
            handleAppId (data) {
                if (data) {
                    this.$router.push({
                        path: '/project-details/' + data
                    });
                }
            },
            checkIfVisible (col, row, colCount) {
                if (!col.rowData) {
                    if (col.isAlternateColumn) {
                        if ((col.alternateField && row[col.alternateField] != null) || row.admin_icd_long_abbr === 'ACF') {
                            return false;
                        }
                    } else if (!col.isVisible) {
                        return false;
                    }

                }
                return true;
            },
            getColSpan (col, row, colCount) {
                if (col.alternateField && row[col.alternateField] != null && colCount === 1) {
                    return 4;
                } else if (row.admin_icd_long_abbr === 'ACF' && colCount === 1) {
                    return 4;
                }
                return 1;
            },
            getSortedList (data) {
                var sortedData = [];
                if (data && data.length > 1) {
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].role_code === 'PI') {
                            sortedData.unshift(data[i]);
                        } else {
                            sortedData.push(data[i]);
                        }
                    }
                    data = sortedData;
                }
                return data;
            },
            backToQuery () {
                this.$router.push('/');
            },
            isObject (data, fieldName) {
                return typeof (data) === 'object' && data !== null;
            },
            setSortDetails ($event, selectedSortColumn) {
                var self = this;

                if (this.isSortableColumn(selectedSortColumn)) {
                    this.table.isLoading = true;

                    //TODO: this is a temp workaround to the hardcoding of .$parent ....dataTables should be
                    //refactored ASAP to remove reference to .$parent!
                    var realParent = self.$parent.setSortDetails ?
                        self.$parent :
                            self.$parent.$parent.setSortDetails ? self.$parent.$parent
                            : undefined;


                    setTimeout(() => {
                        realParent.setSortDetails($event, selectedSortColumn);
                    }, 101);
                }
            },
            getRemainingName (fieldData) {
                var nameStr = '',
                    i = 0;

                if (fieldData.length > 1) {
                    for (i = 1; i < fieldData.length; i++) {
                        nameStr += (nameStr === '' ? fieldData[i].name : '\n' + fieldData[i].name);
                    }
                }
                return nameStr;
            },
            takeColAction (row, fieldName, rowIndex) {
                this.$parent.takeColAction(row, fieldName, rowIndex);
            },
            showDrillDownTable (option) {
                var parentObj = this.$parent;

                if (option.isPINameField) {
                    if (option.isPopOut) {
                        this.openPersonSummary(option.data);
                    }
                } else if (option.isPONameField) {
                    this.openPOSummary(option.data);
                } else { //if (this.fromPage === 'charts' ) {
                    this.$parent.loadDrillDownTableData(option.data, option.field);
                }
            },
            openPersonSummary (data) {
                this.setPersonSummaryProjects(null);

                var id = (new Date()).getTime(),
                myWindow = window.open(window.location.origin + '/PISearch/' + data.profile_id, id, "toolbar=1,scrollbars=1,location=0,statusbar=0,menubar=1,resizable=1,width=1000,height=600,left = 250,top =150");
            },
            openPOSummary (data) {
                this.setPersonSummaryProjects(null);

                var id = (new Date()).getTime(),
                myWindow = window.open(window.location.origin + '/POSearch/' + data.full_name, id, "toolbar=1,scrollbars=1,location=0,statusbar=0,menubar=1,resizable=1,width=1000,height=600,left = 250,top =150");
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/scss/variables.scss';

    .field-tooltip {
        right: 0;
    }
    .scroll-table {
        overflow: hidden;
        position: relative;
        .field-tooltip {
            right: 0;
        }
    }

    .tooltip-toggle::before {
        position: absolute;
        top: 25px;
        left: 0px;
        background-color: #dcdcdc;
        border-radius: 5px;
        color: $grey-link;
        content: attr(data-tooltip);
        padding: 2px 5px;
        text-transform: none;
        -webkit-transition: all 0.5s ease;
        transition: all 0.5s ease;
        width: 100%;
        z-index: 1000;
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
        word-break: break-word;

        .tooltip-toggle::after {
            position: absolute;
            top: -12px;
            left: 9px;
            border-left: 1px solid transparent;
            border-right: 1px solid transparent;
            border-top: 1px solid #dcdcdc;
            content: " ";
            font-size: 0;
            line-height: 0;
            margin-left: -5px;
            width: 0;
        }
    }

    .tooltip-toggle:hover::before,
    .tooltip-toggle:hover::after {
        opacity: 1;
        -webkit-transition: all 0.75s ease;
        transition: all 0.75s ease;
        color: $grey-link;
    }

    .tooltip-toggle::before,
    .tooltip-toggle::after {
        color: #efefef;
        opacity: 0;
        pointer-events: none;
        text-align: left;
    }

    .more-data-loader {
        display: block;
        position: absolute;
        background-color: #555;
        color: #fff;
        font-size: 13px;
        padding: 2px 5px;
        bottom: 0;
        right: 0px;
        z-index: 10;
    }

    .loading {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1000;

        background-color: #a0a0a0;
        opacity: 0.5;
        .loader {
            color: #000;
            left: 45%;
            top: 3%;
        }
    }

    tfoot {
        td {
            font-weight: bold;
        }
    }
</style>
